import {
  Box,
  Center,
  Stack,
  Text,
  Link,
} from "@chakra-ui/layout";
import NextLink from "next/link";

import {
  Switch,
  useColorModeValue as mode,
  Tooltip,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  FormControl,
  Input,
  ModalCloseButton,
  FormLabel,
  ModalFooter,
  Img,
  Button,
} from "@chakra-ui/react";
import theme from "@chakra-ui/theme";
import SearchBar from "components/search-bar";
import Tweets from "components/tweets";
import { CustomHead } from "components/custom-head";
import React, { useEffect, memo } from "react";

import { useSession } from "next-auth/client";

import ProtectedRoute from "components/protected-route";
import SubscribePopup from "components/subscribe-popup";
import { Navbar } from "components/navbar";

import { getList } from "../controllers/bookmark";
import { grow, search, getKeywords, warm } from "../controllers/search";
import { useRouter } from "next/dist/client/router";
import * as analytics from "../utils/analytics";
import { firebaseClient } from "../firebaseClient";
import PuffLoader from "react-spinners/PuffLoader";
import { InfoOutlineIcon } from '@chakra-ui/icons'
import { Page } from "components/page";
import { getAccount } from "../utils/sessionHelper";
import { useFirebaseUser } from "../utils/useFirebaseUser";
import { EditKeywords } from "../components/popups/editKeywords";
import { useOnboardingSteps } from "components/onboard-panel/useOnboardingSteps";
import { useStats } from "hooks/useStats";
import { variant } from "theme/names";
import { EditIconComponent } from "components/icons/EditIconComponent";

export const Application = () => {

  const [session, loading] = useSession();
  const [isPersonalizedSorting, setIsPersonalizedSorting] = React.useState(true);
  const [savedTweet, setSavedTweet] = React.useState([]);
  const [isSending, setIsSending] = React.useState(false);
  const [data, setData] = React.useState(null);
  const router = useRouter();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [refresh, refresher] = React.useState({});
  const [hasFetched, setHasFetched] = React.useState(false);
  const [popupMode, setPopupMode] = React.useState("fail");
  const isAuthenticated = useFirebaseUser();
  const { updateOnboardSteps } = useOnboardingSteps();
  const { updateStatsCounter } = useStats();

  useEffect(() => {
    if (isAuthenticated && !hasFetched) {
      sendRequest(session);
    }
  }, [session, isAuthenticated]);

  const getSavedTweets = async () => {
    if (!loading && getAccount(session)?.id) {
      const savedTweets = await getList(getAccount(session)?.id);
      setSavedTweet(savedTweets);
    }
  };

  useEffect(() => {
    getSavedTweets();
  }, [refresh]);

  // const sendRequest = React.useCallback(async (session, topic) => {
  const sendRequest = async (session) => {

    if (isSending) return;
    setIsSending(true);

    let keywords = getAccount(session)?.keywords;
    if (!getAccount(session)?.keywords || !getAccount(session)?.keywords.join) {
      setPopupMode("fail");
    }

    let params = {
      noHashtag: true,
      isPersonalizedSorting: true,
    }

    if (keywords?.join) {
      //@ts-ignore
      var data = await search(session, keywords.join(","), params, "auto");
      updateStatsCounter("search_via_auto_page");
    }
    else {
      setPopupMode("fail");
      onOpen();
    }
    setHasFetched(true);

    if (!data || data.success === 0) {
      setData(null);
    }
    else {
      setData(data);
    }

    updateOnboardSteps("aiInpiration", "searchInspiration");
    setIsSending(false);
  };

  if (!loading && !session) {
    return <ProtectedRoute />;
  }

  return (
    <Page
      title="Tweet Inspirations For You"
      description="Use these relevant inspirations for your next tweets! Our AI engine selected these for you based on your X account."
      infoTooltipText="These tweets were selected for you by our AI engine, based on your X bio and what you usually talk about."
    >
      <Box mb={5} mt="2">
        <NextLink href={"/settings#search-settings"}>
          <Button
            variant={variant.Button.tertiaryNoBackground}
            p={0}
            m={0}
            // mb={5}
            // as="button"
            // color="gray.500"
            // fontWeight="400"
            // textDecoration="underline"
            onClick={() => {
              // setPopupMode("edit");
              // onOpen();
            }}
            leftIcon={<EditIconComponent />}
          >
            Edit my personalized feed
          </Button>
        </NextLink>
      </Box>
      {
        isSending && (
          <Center pt={10}>
            <PuffLoader color={"hsl(203, 100%, 36%)"} loading={isSending} css="display: block; margin: 0 auto; border-color: red;" size={50} />
          </Center>
        )
      }
      {
        //@ts-ignore
        !isSending && data?.tweets && (
          <Box>
            <Tweets
              //@ts-ignore
              sendRequest={sendRequest}
              savedTweet={savedTweet}
              //@ts-ignore
              tweets={data.tweets}
              //@ts-ignore
              data={data}
              //@ts-ignore
              setData={setData}
              disableBlur={false}
              disableBookmarkButton={false}
              refresher={refresher}
              refresh={refresh}
              disableSaveCsv={true}
              disableEmbed={true}
              disableTryAgain={false}
              disableRefresh={false}
              disableDescriptionWarning={false}
              source="ez4cast"
            />
          </Box>
        )
      }
      {!loading &&
        //@ts-ignore
        data?.tweets &&
        //@ts-ignore
        !session?.user.data?.subscription?.isSubscribed
        && (!session?.user.data?.remainingFreeSearch || session.user.data.remainingFreeSearch <= 0) && (
          <SubscribePopup />
        )}
      <EditKeywords isOpen={isOpen} onClose={onClose} popupMode={popupMode} setPopupMode={setPopupMode} sendRequest={sendRequest} />
    </Page>
  );
};

export default Application;
